import {
  parseAddrBook,
  exportAddrBook,
} from "@/api/projectConfig/projectConfig";
import qs from "qs";

import i18n from "@/language/index";
import {
  validateIp,
  validateServerIp,
  validateIp1,
  validateDNS2,
  validateTop,
  validateEnd,
  validateStart,
  validateLast,
} from "@/views/projectConfig/utils/formCheck";
import { commonState } from "@/store/modules/common";

const getDefaultState = () => {
  return {
    allDeviceNum: 0, // 全局总设备数
    allAreaNum: 0, // 全局总区域数（节点区域）
    DEVICE_NUM_MAX: 8, // 每个区下的设备最大数
    areaData: [],
    areaDeviceData: [],
    addressDeviceList: [], // 外围设备组
    projectInfo: {}, // 项目信息
    fileVersion: "", // 文件版本信息
    areaTypeNameList: [], // 区域层级信息的名称
    submitErrorColumns: [
      {
        title: i18n.t("deviceSip.deviceName"),
        align: "center",
        slot: "deviceName",
      },
      {
        title: i18n.t("updateNewSip.deviceIp"),
        slot: "deviceIp",
        align: "center",
      },
      {
        title: i18n.t("book.areaBy"),
        align: "center",
        key: "groupNamePath",
      },
      {
        title: i18n.t("common.action"),
        align: "center",
        slot: "action",
      },
    ],
    columnList: [
      {
        title: i18n.t("addressBook.deviceId"),
        align: "center",
        key: "deviceId",
      },
      {
        title: i18n.t("data.mac"),
        align: "center",
        key: "mac",
      },
      {
        title: i18n.t("addressBook.sysVersion"),
        align: "center",
        key: "sysVersion",
      },
      {
        title: i18n.t("addressBook.deviceVersion"),
        align: "center",
        key: "deviceVersion",
      },
      {
        title: i18n.t("common.action"), // 操作
        slot: "action",
        align: "center",
      },
    ],
    allFunList: [
      { value: 0, label: i18n.t("updateNewSip.callin") },
      { value: 1, label: i18n.t("updateNewSip.callout") },
      { value: 2, label: i18n.t("deviceSip.monitor") },
      { value: 5, label: i18n.t("updateNewSip.doorAuth") },
      { value: 3, label: i18n.t("deviceSip.lift") },
      // { value: 4, label: i18n.t("deviceSip.rtsp") },
    ], // 添加设备时的设备功能选项
    allDevList: [
      { value: "SI701", label: "SI701" }, // 支持呼入0、呼出1、梯控3
      { value: "SO801", label: "SO801" }, // 支持呼出1、监控2、梯控3、门禁5
      { value: "SO001", label: "SO001" }, // 支持呼入0、呼出1、监控2、梯控3、门禁5
      { value: "SIA01", label: "SIA01" }, // 支持呼入0、呼出1
      { value: "0", label: i18n.t("updateNewSip.other") }
    ], // 添加设备时的设备功能选项
    deviceTypeList: [
      { label: i18n.t("newDeviceType.indoorMachine"), value: 1 }, // 室内机
      { label: i18n.t("newDeviceType.doorPhone"), value: 2 }, // 门口机
      { label: i18n.t("newDeviceType.smallDoor"), value: 3 }, // 小门口机
      { label: i18n.t("newDeviceType.manage"), value: 4 }, // 管理机
      { label: i18n.t("newDeviceType.wall"), value: 5 }, // 围墙机
      { label: i18n.t("newDeviceType.monitor"), value: 6 }, // 网络摄像头
      { label: i18n.t("newDeviceType.unitGuard"), value: 7 }, // 单元管理机
      { label: i18n.t("newDeviceType.networkCard"), value: 8 }, // 联网刷卡头
      { label: i18n.t("newDeviceType.unitCard"), value: 9 }, // 单元刷卡头
      { label: i18n.t("newDeviceType.lift"), value: 10 }, // 电梯联动模块
    ],
    ruleValidateSingleAddArea: {
      name: [
        {
          required: true,
          message: i18n.t("area.checkAreaName"),
          trigger: "blur",
        },
        {
          pattern: commonState.nameReg,
          message: i18n.t("area.areaNameTip2"),
          trigger: "blur",
        },
      ],
      code: [
        {
          required: true,
          message: i18n.t("area.checkAreaNum"),
          trigger: "blur",
        },
        {
          pattern: commonState.areaReg,
          message: i18n.t("check.areaTip"),
          trigger: "blur",
        },
      ],
      // groupCall: [{
      //     required: true,
      //     message: "",
      //     trigger: "blur",
      // }],
    }, // 单个添加区域的表单校验规则
    ruleValidateBaseDevice: {
      name: [
        {
          required: true,
          message: i18n.t("deviceSip.devnameTip1"),
          trigger: "blur",
        },
        {
          pattern: commonState.nameReg,
          message: i18n.t("deviceSip.devnameTip2"),
          trigger: "blur",
        },
      ],
      funList: [
        {
          required: true,
          message: i18n.t("deviceSip.deviceTip"),
          type: "array",
          min: 1,
          trigger: "change",
        },
      ],
    }, // 单个添加设备的基础表单校验规则
    ruleValidateBaseDevice_batch: {
      funList: [
        {
          required: true,
          message: i18n.t("deviceSip.deviceTip"),
          type: "array",
          min: 1,
          trigger: "change",
        },
      ],
    }, // 批量添加设备的基础表单校验规则
    ruleValidateNet1: {
      mode: [],
      mask: [
        {
          required: true,
          message: i18n.t("deviceSip.maskTip1"),
          trigger: "blur",
        },
        {
          pattern: commonState.notAllZoneIpReg, // 禁止输入0.0.0.0
          message: i18n.t("deviceSip.maskTip2"),
          trigger: "blur",
        },
        // { validator: validateIp, trigger: "blur" },
      ],
      gateway: [
        {
          required: true,
          message: i18n.t("deviceSip.gatewayTip1"),
          trigger: "blur",
        },
        {
          pattern: commonState.ipReg,
          message: i18n.t("deviceSip.gatewayTip2"),
          trigger: "blur",
        },
        { validator: validateIp, trigger: "blur" },
      ],
      ip: [
        {
          required: true,
          message: i18n.t("deviceSip.ipTip1"),
          trigger: "blur",
        },
        {
          pattern: commonState.notAllZoneIpReg, // // 禁止输入0.0.0.0
          message: i18n.t("updateNewSip.ipAndMaskTip3"),
          trigger: "blur",
        },
        // { validator: validateIp1, trigger: "blur" },
      ],
      dns1: [
        {
          required: true,
          message: i18n.t("deviceSip.dns1Tip1"),
          trigger: "blur",
        },
        {
          pattern: commonState.ipReg,
          message: i18n.t("deviceSip.dns1Tip2"),
          trigger: "blur",
        },
        { validator: validateIp, trigger: "blur" },
      ],
      dns2: [{ validator: validateDNS2, trigger: "blur" }],
    }, // 添加设备的Net表单校验规则
    ruleValidateSip1_batch: {
      password: [
        {
          required: true,
          message: i18n.t("deviceSip.passwordTip1"),
          trigger: "blur",
        },
        {
          min: 8,
          max: 32,
          message: i18n.t("validate.pwdLengthReg"),
          trigger: "blur",
        },
        {
          pattern: commonState.passwordReg,
          message: i18n.t("validate.pwdReg"),
          trigger: "blur",
        },
      ],
      serviceIp: [
        {
          required: true,
          message: i18n.t("deviceSip.serviceTip1"),
          trigger: "blur",
        },

        { validator: validateServerIp, trigger: "blur" },
      ],
    }, // 批量添加设备的sip1配置
    ruleValidateSip2_batch: {
      password: [
        {
          required: true,
          message: i18n.t("deviceSip.passwordTip1"),
          trigger: "blur",
        },
        {
          min: 8,
          max: 32,
          message: i18n.t("validate.pwdLengthReg"),
          trigger: "blur",
        },
        {
          pattern: commonState.passwordReg,
          message: i18n.t("validate.pwdReg"),
          trigger: "blur",
        },
      ],
      serviceIp: [
        {
          required: true,
          message: i18n.t("deviceSip.serviceTip1"),
          trigger: "blur",
        },
        { validator: validateServerIp, trigger: "blur" },
      ],
    }, // 批量添加设备的sip2配置
    ruleValidateSip1_1: {
      account: [
        {
          required: true,
          message: i18n.t("deviceSip.nameTip1"),
          trigger: "blur",
        },
      ],
    }, // 单个添加设备的sip1选中直连模式下的表单校验规则
    ruleValidateSip1_2: {
      account: [
        {
          required: true,
          message: i18n.t("deviceSip.nameTip2"),
          trigger: "blur",
        },
      ],
      password: [
        {
          required: true,
          message: i18n.t("deviceSip.passwordTip1"),
          trigger: "blur",
        },
        {
          min: 8,
          max: 32,
          message: i18n.t("validate.pwdLengthReg"),
          trigger: "blur",
        },
        {
          pattern: commonState.passwordReg,
          message: i18n.t("validate.pwdReg"),
          trigger: "blur",
        },
      ],
      serviceIp: [
        {
          required: true,
          message: i18n.t("deviceSip.serviceTip1"),
          trigger: "blur",
        },

        { validator: validateServerIp, trigger: "blur" },
      ],
    }, // 单个添加设备的sip1选中服务器模式下的表单校验规则
    ruleValidateSip2_1: {
      account: [
        {
          required: true,
          message: i18n.t("deviceSip.nameTip1"),
          trigger: "blur",
        },
      ],
    }, // 单个添加设备的sip2选中直连模式下的表单校验规则
    ruleValidateSip2_2: {
      account: [
        {
          required: true,
          message: i18n.t("deviceSip.nameTip2"),
          trigger: "blur",
        },
      ],
      password: [
        {
          required: true,
          message: i18n.t("deviceSip.passwordTip1"),
          trigger: "blur",
        },
        {
          min: 8,
          max: 32,
          message: i18n.t("validate.pwdLengthReg"),
          trigger: "blur",
        },
        {
          pattern: commonState.passwordReg,
          message: i18n.t("validate.pwdReg"),
          trigger: "blur",
        },
      ],
      serviceIp: [
        {
          required: true,
          message: i18n.t("deviceSip.serviceTip1"),
          trigger: "blur",
        },
        // {
        //     pattern: commonState.ipReg,
        //     message: i18n.t("deviceSip.serviceTip2"),
        //     trigger: "blur",
        // },
        { validator: validateServerIp, trigger: "blur" },
      ],
    }, // 单个添加设备的sip2选中服务器模式下的表单校验规则
    ruleValidateType2: {
      startNum: [
        {
          required: true,
          message: i18n.t("area.checkStartNum1"),
          trigger: "blur",
        },
        {
          pattern: commonState.areaReg,
          message: i18n.t("area.checkStartNum"),
          trigger: "blur",
        },
      ],
      endNum: [
        {
          required: true,
          message: i18n.t("area.checkEndNum1"),
          trigger: "blur",
        },
        {
          pattern: commonState.areaReg,
          message: i18n.t("area.checkEndNum"),
          trigger: "blur",
        },
      ],
      nameTop: [
        {
          pattern: commonState.nameReg,
          message: i18n.t("area.areaNameTip2"),
          trigger: "blur",
        },
      ],
      nameLast: [
        {
          pattern: commonState.nameReg,
          message: i18n.t("area.areaNameTip2"),
          trigger: "blur",
        },
      ],
      // groupCall: [{
      //     required: true,
      //     message: "",
      //     trigger: "blur",
      // }],
    }, // 批量添加区域的连续添加表单校验规则
    ruleValidateType3: {
      topStart: [
        {
          required: true,
          message: i18n.t("area.checkTopStart1"),
          trigger: "blur",
        },
        { validator: validateTop, trigger: "blur" },
      ],
      topEnd: [
        {
          required: true,
          message: i18n.t("area.checkTopEnd1"),
          trigger: "blur",
        },
        { validator: validateEnd, trigger: "blur" },
      ],
      lastStart: [
        {
          required: true,
          message: i18n.t("area.checkLastStart1"),
          trigger: "blur",
        },
        { validator: validateStart, trigger: "blur" },
      ],
      lastEnd: [
        {
          required: true,
          message: i18n.t("area.checkLastEnd1"),
          trigger: "blur",
        },
        { validator: validateLast, trigger: "blur" },
      ],
      nameTop: [
        {
          pattern: commonState.nameReg,
          message: i18n.t("area.areaNameTip2"),
          trigger: "blur",
        },
      ],
      nameLast: [
        {
          pattern: commonState.nameReg,
          message: i18n.t("area.areaNameTip2"),
          trigger: "blur",
        },
      ],
      // groupCall: [{
      //     required: true,
      //     message: "",
      //     trigger: "blur",
      // }],
    }, // 批量添加区域的矩阵添加表单校验规则
  };
};

const state = getDefaultState();
const mutations = {
  // 设置区域节点总数
  SET_ALLAREANUM: (state, number) => {
    state.allAreaNum = number;
  },
  // 设置设备节点总数据
  SET_ALLDEVICENUM: (state, number) => {
    state.allDeviceNum = number;
  },
  SET_AREADATA: (state, array) => {
    state.areaData = array;
  },
  SET_AREADEVICEDATA: (state, array) => {
    state.areaDeviceData = array;
  },
  SET_ADDRESSDEVICELIST: (state, array) => {
    state.addressDeviceList = array;
  },
  SET_AREATYPENAMELIST: (state, array) => {
    state.areaTypeNameList = array;
  },
  SET_PROJECTINFO: (state, object) => {
    state.projectInfo = object;
  },
  SET_FILEVERSION: (state, string) => {
    state.fileVersion = string;
  },
};

const actions = {
  parseAddrBook({ commit }, targetData) {
    return new Promise((resolve, reject) => {
      parseAddrBook(targetData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exportAddrBook({ commit }, targetData) {
    return new Promise((resolve, reject) => {
      exportAddrBook(targetData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
